import { MessageState } from "./messageTypes";

export const initialState: MessageState = {
  message: undefined,
};
